/**
 * Validates email format.
 */
export function isValidEmail(email: string): boolean {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

/**
 * Validates password meets requirements.
 * - At least 6 characters
 */
export function isValidPassword(password: string): boolean {
  return password.length >= 6;
}

/**
 * Validates display name.
 * - 2-50 characters
 * - No special characters except spaces
 */
export function isValidDisplayName(name: string): boolean {
  const trimmed = name.trim();
  if (trimmed.length < 2 || trimmed.length > 50) return false;

  const nameRegex = /^[a-zA-Z0-9\s]+$/;
  return nameRegex.test(trimmed);
}

/**
 * Validates room code format.
 * - Exactly 6 alphanumeric characters
 */
export function isValidRoomCode(code: string): boolean {
  const codeRegex = /^[A-Z0-9]{6}$/;
  return codeRegex.test(code.toUpperCase());
}

/**
 * Validates room name.
 * - 1-100 characters
 */
export function isValidRoomName(name: string): boolean {
  const trimmed = name.trim();
  return trimmed.length >= 1 && trimmed.length <= 100;
}
